"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractDomain = exports.PRODUCTION_CANADA_ENDPOINT = exports.PRODUCE_ENDPOINT = exports.PRODUCE_BATCH_ENDPOINT = exports.PRODUCTION_DOMAIN = exports.DEVELOPMENT_DOMAIN = void 0;
exports.DEVELOPMENT_DOMAIN = 'http://localhost:8082';
exports.PRODUCTION_DOMAIN = 'https://monorail-edge.shopifysvc.com';
exports.PRODUCE_BATCH_ENDPOINT = '/unstable/produce_batch';
exports.PRODUCE_ENDPOINT = '/v1/produce';
exports.PRODUCTION_CANADA_ENDPOINT = 'https://monorail-edge-ca.shopifycloud.com/v1/produce';
function extractDomain(urlString) {
    return "https://".concat(new URL(urlString).hostname);
}
exports.extractDomain = extractDomain;
